import ApiBase from '@pulse/services/ApiBase';

export default class MerchantService extends ApiBase {
  constructor(apiBaseUrl) {
    super(apiBaseUrl);
  }

  async find(storeId) {
    const { data } = await this.client.get(`stores/${storeId}`);

    return data;
  }

  async findBySlug(slug) {
    const { data } = await this.client.get(`stores/slug?slug=${slug}`);

    return data;
  }
}
